
define([
	"dojo/_base/declare",
	"csi/heading/StringType"
], function(declare, StringType) {
	return declare(StringType, {
		/**
		* @override
		* Show size only at file level
		*/
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			if (ctx.getNode().Type === "directory") {
				return;
			}
			return ctx.getNode().DisplaySize;
		}
	});
});